/** Prod-диагностика падений «Хранителей» — только этот user_id (+ __DEV__). */
export const GUARDIANS_PROD_DIAGNOSTICS_USER_ID = 637

export function resolveProfileUserId(profile: unknown): number | null {
  if (!profile || typeof profile !== "object") return null
  const record = profile as Record<string, unknown>
  const raw = record.user_id ?? record.id ?? record.userId ?? record.uid
  const n = Number(raw)
  return Number.isFinite(n) && n > 0 ? n : null
}

export function canUseGuardiansProdDiagnostics(profile: unknown): boolean {
  if (__DEV__) return true
  return resolveProfileUserId(profile) === GUARDIANS_PROD_DIAGNOSTICS_USER_ID
}

/** Лаборатория боевых FX — только user_id 637 */
export function canUseBattleFxLab(profile: unknown): boolean {
  return resolveProfileUserId(profile) === GUARDIANS_PROD_DIAGNOSTICS_USER_ID
}

/**
 * Видеть других игроков на карте.
 * Всем — отложенные «тени»; user 637 дополнительно получает live с бэкенда.
 */
export function canSeeOtherPlayersOnMap(_profileOrUserId?: unknown): boolean {
  return true
}

/** Live-геолокации без задержки следа (как до теней). */
export function canSeeLivePlayersOnMap(profileOrUserId: unknown): boolean {
  if (typeof profileOrUserId === "number") {
    return Number(profileOrUserId) === GUARDIANS_PROD_DIAGNOSTICS_USER_ID
  }
  return resolveProfileUserId(profileOrUserId) === GUARDIANS_PROD_DIAGNOSTICS_USER_ID
}
